import React from "react";
import { Utils, AlertMessagesService, OmniCheckboxComponent, OmniDropdownComponent, OmniIconComponent, OmniTooltipNextComponent, AccordionComponent, InputChips } from "../../../../shared";
import { ObjectsHierarchyService } from "../../";
import { html } from "lit";

export class ObjectsHierarchyDetailsComponent extends React.Component {
    defaultState = {
        endDate: '',
        startDate: '',
        objectsData: [],
        displayDeleteModal: false,
        templateName: '',
        deleteModalData: {},
        customColumnsData: [],
        defaultColumnsData: [],
        hierarchyObjectData: [],
        planIds: this.props.state.campaignObj.row.planIds || [],
    };
    
    emptyColumnsMessage = true;
    existingColumnsIsUpdated = false;
    
    constructor(props) {
        super(props);
        this.state = this.defaultState;
        this.tableRowData = this.props.state.campaignObj.row,
        this.customColumnOptions = (props.state.campaignObj?.columnOptions && props.state.campaignObj?.columnOptions.map(item => ({ id: item?.code, value: item?.name }))) || [];
    }

    /**
     * Lifecycle method to fetch the data from the API when the component is mounted.
     */
    componentDidMount() {
        this.props.setSpinnerCount(1);
        const tableRowData = this.props.state.campaignObj.row;
        if (tableRowData.id === 1) { // id 1 indicates default template, so set the default hierarchy objects
            this.getDefaultHierarchyObjects(tableRowData);
        } else {
            this.fetchHierarchyObject(tableRowData);
        }
        this.loadCustomColumns(tableRowData);
    }

    /**
     * Loads custom columns from the hierarchy objects and updates the state with the custom columns data.
     */
    loadCustomColumns = (data) => {
        const customColumnData = [];
        const defaultColumnData = [];
        data.hierarchyObjects.map((item) => { // Iterate over the hierarchy objects in the table row data
            const { type, level, hierarchyObjectColumns, hierarchyObjectCustomColumns } = item;
            const id = hierarchyObjectColumns?.length;
            hierarchyObjectCustomColumns.forEach((column, index) => { // Iterate over the custom columns and create custom column objects
                const columnName = column?.columnName;
                const sourceColumnName = column?.sourceColumnName;
                const uniqueChecked = column?.isPartOfTierId;
                const isPartOfDisplayName = column?.isPartOfDisplayName;
                const isAGroupByColumn = column.isAGroupByColumn;
                const isMinSetColumn = column.isMinSetColumn;
                const customColumnObject = { id: id + index + 1, type, level, columnName, uniqueChecked,isPartOfDisplayName, isAGroupByColumn, isMinSetColumn, sourceColumnName: column?.sourceColumnName };
                customColumnData.push(customColumnObject);
            });
        });
        // Update the state with the custom columns data
        this.setState({ customColumnsData: [...this.state.customColumnsData, ...customColumnData] });
    };

    /**
     * Sets the default hierarchy objects and updates the component state.
     * @param {Object} data - The data object containing hierarchy objects.
     * @returns {void}
     */
    getDefaultHierarchyObjects = (data) => {
        this.props.setSpinnerCount(0);
        this.emptyColumnsMessage = !!data?.hierarchyObjects?.length
        this.setState({ objectsData: data?.hierarchyObjects });
        document.querySelector('.template-name-input').focus();
    };

    /**
     * Fetches the hierarchy object and updates the component state.
     * @param {Object} data - The data object containing hierarchy objects.
     * @returns {void}
     */
    fetchHierarchyObject = (data) => {
        this.props.setSpinnerCount(0);
        this.emptyColumnsMessage = !!data?.hierarchyObjects?.length
        this.setState({
            startDate: data?.campaignStart || '',
            endDate: data?.campaignEnd || '',
            objectsData: data?.hierarchyObjects,
            templateName: data?.templateName,
        });
    };

    /**
     * Adds a custom column to the `customColumnsData` state arrays based on the provided ID, type, and level.
     * @param {number} id The ID of the custom column to add.
     * @param {string} type The type of the custom column to add.
     * @param {string} level The level of the custom column to add.
     * @returns {void}
     */
    addCustomColumn = (id, type, level) => {
        const newCustomColumn = { id, type, level, columnName: '', uniqueChecked: false, isPartOfDisplayName: false, sourceColumnName:''  }; // Create a new custom column object with the provided ID, type, and level
        this.setState({ // Update the `customColumnsData` and `hierarchyObjectData` state arrays with the new custom column
            customColumnsData: [...this.state.customColumnsData, newCustomColumn],
            hierarchyObjectData: [...this.state.hierarchyObjectData, newCustomColumn]
        });
    }

    /**
     * Opens the delete modal with the provided data.
     * @param {Object} data The data object containing the ID, type, and level of the custom column to delete.
     * @returns {void}
     */
    handleOpenDeleteModal = (data) => {
        this.setState({ displayDeleteModal: true, deleteModalData: data });
    };

    /**
     * Removes a custom column from the `customColumnsData` state arrays based on the provided ID and type.
     * @param {Object} data - The data object containing the ID and type of the custom column to remove.
     * @returns {void}
     */
    removeCustomColumn = (data) => {
        if (this.state.hierarchyObjectData.length === 0) { // Check if the hierarchyObjectData array is empty and set the existingColumnsIsUpdated flag accordingly
            this.existingColumnsIsUpdated = true;
        } else {
            this.existingColumnsIsUpdated = false;
        }
        this.setState({ // Update the component state by closing the delete modal and filtering out the removed column
            displayDeleteModal: false,
            customColumnsData: this.filterRemovedColumn(this.state.customColumnsData, data),
            hierarchyObjectData: this.filterRemovedColumn(this.state.hierarchyObjectData, data, true),
        });
    };

    /**
     * Filters out a removed column from the provided data array and updates the IDs of the remaining columns.
     * This method filters out the column specified by the `columnData` from the `data` array.
     * It then updates the IDs of the remaining columns that match the type and level of the removed column.
     * If `addCustomColumnLength` is true, it adjusts the ID calculation based on the custom columns length.
     * @param {Array} data - The array of columns to filter and update.
     * @param {Object} columnData - The data object containing the ID, type, level, defaultColumnsLength, and customColumnsLength of the column to remove.
     * @param {boolean} [addCustomColumnLength=false] - Flag indicating whether to adjust the ID calculation based on the custom columns length.
     * @returns {Array} The filtered and updated array of columns.
     */
    filterRemovedColumn = (data = [], columnData, addCustomColumnLength = false) => {
        let uniqueId = 0;
        const { id, type, level, defaultColumnsLength, customColumnsLength } = columnData;
        const isCustomColumnLength = addCustomColumnLength ? customColumnsLength - data.length : 0;
        return data.filter((item) => item.id !== id || item.type !== type || item.level !== level)
            .map((item) => {
                if (item.type === type && item.level === level) {
                    return { ...item, id: defaultColumnsLength + isCustomColumnLength + ++uniqueId };
                } else {
                    return item;
                }
            });
    };

    /**
     * Updates the state with the changed data for a specific column.
     * This method updates the `customColumnsData` and `hierarchyObjectData` state arrays based on the provided column data, change type, and updated value.
     * It checks if the column exists in the `customColumnsData` and `hierarchyObjectData` arrays, and updates or adds the column accordingly.
     * @param {Object} columnData - The data object containing the column details.
     * @param {string} changeType - The type of change to be applied to the column.
     * @param {any} updatedValue - The new value to be set for the specified change type.
     * @returns {void}
     */
    onDataChange = (columnData, changeType, updatedValue) => {
        const { id, type, level } = columnData;
        let customColumnsData = this.state.customColumnsData;
        let hierarchyObjectData = this.state.hierarchyObjectData;
        const customColumnIsExist = customColumnsData.filter(item => item.id === id && (item.type === type && item.level === level));
        const hierarchyColumnIsExist = hierarchyObjectData.filter(item => item.id === id && (item.type === type && item.level === level));
        const newCustomColumn = { ...columnData, [changeType]: updatedValue };
        if (customColumnIsExist?.length > 0 && hierarchyColumnIsExist.length === 0) {
            hierarchyObjectData = [...this.state.hierarchyObjectData, newCustomColumn]; // If the column exists in customColumnsData but not in hierarchyObjectData, add it to hierarchyObjectData
            customColumnsData = this.updatedData(customColumnsData, columnData, changeType, updatedValue); // Update the customColumnsData array with the new value
        } else {
            if(hierarchyColumnIsExist.length === 0 && customColumnIsExist.length === 0){
                hierarchyObjectData = [...this.state.hierarchyObjectData, newCustomColumn];

            }else{
                customColumnsData = this.updatedData(customColumnsData, columnData, changeType, updatedValue); // Update both customColumnsData and hierarchyObjectData arrays with the new value
                hierarchyObjectData = this.updatedData(hierarchyObjectData, columnData, changeType, updatedValue);
            }
            if(hierarchyObjectData.length){
                let objectsData = this.state.objectsData;
                objectsData.forEach((item) => {
                    if(item.type === type && item.level === level){
                        item.hierarchyObjectColumns.forEach((values,index) => {
                            if (index+1 === id)
                                values[changeType] = updatedValue;
                        });
                    }
                });
                this.setState({objectsData:objectsData});
            }
        }
        this.setState({ customColumnsData, hierarchyObjectData });
    };

    /**
     * Updates the data array with the changed value for a specific column.
     * This method updates the data array based on the provided column data, change type, and updated value.
     * It checks if the column exists in the data array and updates the column with the new value.
     * @param {Array} data - The array of columns to update.
     * @param {Object} columnData - The data object containing the column details.
     * @param {string} changeType - The type of change to be applied to the column.
     * @param {any} updatedValue - The new value to be set for the specified change type.
     * @returns {Array} The updated data array.
     */
    updatedData = (data, columnData, changeType, updatedValue) => {
        const { id, type, level, sourceColumnName } = columnData;
        return data.map(item => {
            if (item.id === id && (item.type === type && item.level === level))
                // return { ...item, [changeType]: updatedValue,sourceColumnName:item.sourceColumnName || columnData.sourceColumnName}
                return { ...item, sourceColumnName, [changeType]: updatedValue }
            else
                return item
        });
    };

    /**
     * Handles the cancel action, reverting to the previous page and clearing the state.
     */
    onCancel = () => {
        this.props.navigate(-1)
        this.setState({ customColumnsData: [], });
    }

    /**
     * Handles the save and publish action, displaying a success message and navigating back to the previous page.
     * @param {string} state - The state indicating whether the action is 'Saved' or 'Published'.
     * @returns {void}
     */
    onSaveAndPublish = (state) => {
        this.props.setSpinnerCount(1);
        const id = this.tableRowData?.id; // Get the ID of the table row data
        const hierarchyPayload = this.createSaveAndPublishPayload(state);
        const apiCallName = id === 1 ? 'addHierarchyTemplate' : 'updateHierarchyTemplate';
        ObjectsHierarchyService[apiCallName](hierarchyPayload).then(() => {
            this.props.setSpinnerCount(0);
            this.props.navigate(-1);
        }).catch((error) => {
            this.props.setSpinnerCount(0);
            const errorData = error.response?.data;
            AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.onSaveAndPublish(state), title: `${errorData?.httpStatus} - Unable to ${state === 'Saved' ? 'save' : 'publish'} the template`, bodyMsgArr: [html`Error type: ${errorData?.errorType}<br/>Error message: ${errorData?.errorMessage}`] }]);
        });
    };

    /**
     * Creates the payload for saving or publishing the hierarchy template.
     * This method constructs the payload by including the necessary columns, plan IDs, and other relevant data.
     * It checks if the plan IDs or columns have been updated and includes them in the payload if necessary.
     * @param {string} state - The state indicating whether the action is 'Saved' or 'Published'.
     * @returns {Array} The payload for saving or publishing the hierarchy template.
     */
    createSaveAndPublishPayload = (state) => {
        let columns = {};
        let planIds = {};
        // Checks if `planIds` in `state.tableRowData` matches `state.planIds` in length and content
        // defaulting to an empty array if `state.tableRowData.planIds` is null or undefined
        const planIdsIsUpdated = (this.tableRowData?.planIds || [])?.length === this.state.planIds?.length && // Check if the plan IDs have been updated
            (this.tableRowData?.planIds || []).every(item => this.state.planIds.includes(item));
        if (!planIdsIsUpdated || this.state.planIds?.length) {
            planIds = { planIds: this.state.planIds };
        }
        if (this.state.hierarchyObjectData?.length || this.existingColumnsIsUpdated) { // Check if the hierarchy object data or existing columns have been updated
            let hierarchyObjectData = [...this.state.hierarchyObjectData];
           let bothCoulmnsData = [...this.state.customColumnsData];
           //merging both coulmn value in single var
           hierarchyObjectData.forEach(item=>{
                let value = bothCoulmnsData.find(val=> item.id == val.id);
                if(!value){
                    bothCoulmnsData.push(item);
                }
           })
            columns = { columns: Utils.createColumnsPayload(bothCoulmnsData) };
        }
        const { id, isActive, clientName } = this.tableRowData;
        const templateId = id === 1 ? null : { id };
        // Construct the hierarchy payload
        const hierarchyPayload = [
            {
                // isActive: state === 'Saved' ? false : true,
                isActive,
                clientName,
                templateName: this.state.templateName,
                mediaOpsState: state,
                campaignStart: this.state.startDate,
                campaignEnd: this.state.endDate,
                ...templateId,
                ...columns,
                ...planIds,
            }
        ];

        return hierarchyPayload;
    };

    // Renders the default columns for the provided type.
    defaultColumns = (data, type, level) => {
        return (
            <div className="default-columns">
                <AccordionComponent
                    accordion={{ header: "Default columns", isOpen: false }}
                >
                    <div className='default-column-container'>
                        <div className="grid-cols">
                            {data && data.map((item, index) => {
                                let columnId = index+1;
                                return (
                                    <div key={index} className="default-column-section">
                                            <div className="column-name">
                                                <span className="label">Column {columnId}</span>
                                                <div>{item.columnName}</div>
                                            </div>
                                            <div className="checkbox-col">
                                                <div className="label-tooltip-container">
                                                    <label htmlFor={`display-id-${columnId}`} className="label">
                                                        Display Name
                                                    </label>
                                                    <OmniTooltipNextComponent>
                                                        <omni-icon slot="invoker" class="is-size-3" icon-id="omni:informative:info" />
                                                        <div slot="content">
                                                            This Field will be added to the Display Name of the object
                                                        </div>
                                                    </OmniTooltipNextComponent>
                                                </div>
                                                <div>
                                                    <OmniCheckboxComponent id={`display-id-${columnId}`} name={`display-id-${columnId}`}
                                                        checked={item?.isPartOfDisplayName}
                                                        onCheckboxChange={(event) => this.onDataChange({id: columnId, type, level, uniqueChecked: item?.isPartOfTierId || false,isMinSetColumn:item.isMinSetColumn, isAGroupByColumn:item.isAGroupByColumn,columnName: item?.columnName || '', sourceColumnName:item?.sourceColumnName }, 'isPartOfDisplayName', event.target.checked)}>
                                                        <span className="checkbox-label">
                                                            Add Display Name
                                                        </span>
                                                    </OmniCheckboxComponent>
                                                </div>
                                            </div>
                                        
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </AccordionComponent>
            </div>
        );
    }

    /**
     * Returns the date in the format "Mon DD, YYYY" from the provided value.
     * @param {string} value The value to format.
     * @returns {string} The formatted date.
     */
    getDate = (value) => {
        const date = value && value.includes('T') ? value.split('T')[0] : value === 'string' ? '' : value;
        return Utils.formatDateObject(date);
    }

    /**
     * Renders the custom columns for the provided type and level.
     * This method filters the custom columns data based on the provided type and level.
     * It then renders an accordion component containing dropdowns for each custom column,
     * along with options to add new custom columns and set unique IDs.
     * @param {number} defaultColumnsLength - The length of the default columns.
     * @param {string} type - The type of the custom columns.
     * @param {string} level - The level of the custom columns.
     * @returns {JSX.Element} The rendered custom columns component.
     */
    customColumns = (defaultColumnsLength, type, level) => {

        const filterData = this.state.customColumnsData.filter((filterItem) => filterItem.type === type && filterItem.level === level);
        const customColumnsLength = filterData.length;
        return (
            <div className="custom-columns">
                <AccordionComponent
                    accordion={{ header: "Custom columns", isOpen: false }}>
                    <div className="add-columns">
                        <div className="grid-cols">
                            {filterData.map((dropdownItem, index) => {
                                const dropdownId = dropdownItem.id;
                                let dropdownValue = dropdownItem.columnName?[dropdownItem.columnName]:[];
                                if (this.customColumnOptions.some(item => item.id === dropdownItem.columnName)) {
                                    dropdownValue = [this.customColumnOptions.find(item => item.id === dropdownItem.columnName)];
                                }
                                return (
                                    <div className="dropdown-container" key={index}>
                                        <div className="dropdown-col">
                                            <span className="label">Column {dropdownId}</span>
                                            <OmniDropdownComponent
                                                hidefooter
                                                placeholder="Select column option"
                                                typeahead
                                                value={dropdownValue}
                                                searchindropdown
                                                dynamicadditions
                                                options={this.customColumnOptions}
                                                onDropdownChange={(event) => {
                                                    let value = event.target.value;
                                                    if (typeof event.target.value[0] === 'string') {
                                                        value = [{ id: event.target.value[0], value: event.target.value[0] }];
                                                    };
                                                    this.onDataChange({ id: dropdownId, type, level, isMinSetColumn:dropdownItem.isMinSetColumn, isAGroupByColumn:dropdownItem.isAGroupByColumn, uniqueChecked: dropdownItem?.uniqueChecked || false, isPartOfDisplayName: dropdownItem?.isPartOfDisplayName || false, sourceColumnName: value[0].value }, 'columnName', value[0].id)
                                                }}
                                            />
                                        </div>
                                        <div className='unique-remove-container'>
                                            <button className="icon" onClick={() => this.handleOpenDeleteModal({ id: dropdownId, type, level, defaultColumnsLength, customColumnsLength })}>
                                                <omni-icon icon-id="omni:interactive:remove" class="is-size-2" />
                                            </button>
                                            <div className="checkbox-col">
                                                <label htmlFor={`unique-id-${dropdownId}`} className="label">Unique ID {' '}
                                                    <OmniTooltipNextComponent>
                                                        <omni-icon slot="invoker" class="is-size-3" icon-id="omni:informative:info" />
                                                        <div slot="content">
                                                            setting Unique ID on a column, the object will be split on that column in Media Ops Hub. To see the change you need to set it in your planning system too.
                                                        </div>
                                                    </OmniTooltipNextComponent>
                                                </label>
                                                <div>
                                                    <OmniCheckboxComponent id={`unique-id-${dropdownId}`} name={`unique-id-${dropdownId}`}
                                                        checked={dropdownItem?.uniqueChecked}
                                                        onCheckboxChange={(event) => this.onDataChange({ id: dropdownId, type, level, isMinSetColumn:dropdownItem.isMinSetColumn, isAGroupByColumn:dropdownItem.isAGroupByColumn, columnName: dropdownItem?.columnName || '', isPartOfDisplayName: dropdownItem?.isPartOfDisplayName || false, sourceColumnName: dropdownItem?.sourceColumnName || '' }, 'uniqueChecked', event.target.checked)}>
                                                        <span className="checkbox-label">
                                                            Add Unique ID to column
                                                        </span>
                                                    </OmniCheckboxComponent>
                                                </div>
                                            </div>
                                            <div className="checkbox-col">
                                                <label htmlFor={`display-id-${dropdownId}`} className="label">
                                                    Display Name
                                                    <OmniTooltipNextComponent>
                                                        <omni-icon slot="invoker" class="is-size-3" icon-id="omni:informative:info" />
                                                        <div slot="content">
                                                        This Field will be added to the Display Name of the object
                                                        </div>
                                                    </OmniTooltipNextComponent>
                                                </label>
                                                <div>
                                                    <OmniCheckboxComponent id={`dropdownId-id-${dropdownId}`} name={`dropdownId-id-${dropdownId}`}
                                                        checked={dropdownItem?.isPartOfDisplayName}
                                                        onCheckboxChange={(event) => this.onDataChange({ id: dropdownId, type, level, isMinSetColumn:dropdownItem.isMinSetColumn, isAGroupByColumn:dropdownItem.isAGroupByColumn,  columnName: dropdownItem?.columnName || '', uniqueChecked: dropdownItem?.uniqueChecked || false, sourceColumnName:dropdownItem.sourceColumnName }, 'isPartOfDisplayName', event.target.checked)}>
                                                        <span className="checkbox-label">
                                                            Add Display Name
                                                        </span>
                                                    </OmniCheckboxComponent>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                            <OmniTooltipNextComponent>
                                <button slot='invoker' className="icon" onClick={() => this.addCustomColumn(defaultColumnsLength + customColumnsLength + 1, type, level)}>
                                    <omni-icon icon-id="omni:interactive:add" />
                                </button>
                                <div slot='content'>Add custom column</div>
                            </OmniTooltipNextComponent>
                        </div>
                        {customColumnsLength === 0 && <div className="helper-text">
                            <p>To add custom column, click + button and select dropdown option.</p>
                        </div>}
                    </div>
                </AccordionComponent>
            </div>
        )
    }

    render() {

        return (
            <div className="objects-hierarchy-details-container">

                <div className="sectionWrapper">
                    <div className="object-hierarchy-header">
                        <div className="header-title">Hierarchy Objects Options</div>

                        <div className="first-section">
                            <div className="template-name">
                                <span className="label">* Template name</span>
                                <input type="text"
                                    value={this.state.templateName}
                                    placeholder="Enter template name"
                                    className="input template-name-input"
                                    onChange={(event) => this.setState({ templateName: event.target.value })}
                                />
                            </div>
                            <div className="start-date date-box">
                                <span className="label">Start date</span>
                                <input
                                    id="Start Date"
                                    data-date={this.getDate(this.state.startDate) || "Mon DD, YYYY"}
                                    type="date"
                                    className="input start-date-input"
                                    onChange={(event) => this.setState({ startDate: event.target.value })}
                                    value={this.state.startDate}
                                />
                            </div>
                            <div className="end-date date-box">
                                <span className="label">End date</span>
                                <input
                                    id="End Date"
                                    data-date={this.getDate(this.state.endDate) || "Mon DD, YYYY"}
                                    type="date"
                                    className="input end-date-input"
                                    onChange={(event) => this.setState({ endDate: event.target.value })}
                                    value={this.state.endDate}
                                />
                            </div>
                            <div className="planIds">
                                <span className="label">Plan ID</span>
                                <InputChips
                                    id='planIds-input'
                                    placeholder="Enter plan id"
                                    containerClassName='input planIds-input-container'
                                    defaultValue={this.state.planIds}
                                    onChange={(value) => this.setState({ planIds: value })}
                                />
                            </div>
                        </div>
                        <div className="separator" />
                    </div>
                    {this.emptyColumnsMessage ?
                        this.state.objectsData.map((item, index) =>
                        (
                            <div key={index}>
                                <div className="second-section">
                                    <div className="objects">
                                        <div>
                                            <span className="label">Object level</span>
                                            <div>{item.level}</div>
                                        </div>
                                        <div>
                                            <span className="label">Object type</span>
                                            <div>{item.type}</div>
                                        </div>
                                    </div>
                                    {this.defaultColumns(item?.hierarchyObjectColumns ? item?.hierarchyObjectColumns : [], item.type,item.level)}
                                    {this.customColumns(item?.hierarchyObjectColumns ? item?.hierarchyObjectColumns.length : 0, item.type, item.level)}
                                    {this.state.objectsData.length !== index + 1 && <div className="separator" />}
                                </div>
                            </div>
                        ))
                        : <div className="no-data">No columns are available for this Campaign Object</div>}
                </div>

                <div className="actionButtons">
                    <button className="cancel tertiary" onClick={this.onCancel}>
                        <span className="cancel-text">Cancel</span>
                    </button>
                    <button
                        className='save secondary'
                        onClick={() => this.onSaveAndPublish('Saved')}
                        disabled={Utils.disableHierarchyPublishButton(this.state, this.tableRowData, this.existingColumnsIsUpdated)}>
                        <span className="save-text">Save as Draft</span>
                    </button>
                    <button
                        className={`save ${Utils.disableHierarchyPublishButton(this.state, this.tableRowData, this.existingColumnsIsUpdated, true) ? 'secondary' : ''}`}
                        onClick={() => this.onSaveAndPublish('Submitted')}
                        disabled={Utils.disableHierarchyPublishButton(this.state, this.tableRowData, this.existingColumnsIsUpdated, true)}>
                        <span className="save-text">Publish Template</span>
                    </button>
                </div>

                {this.state.displayDeleteModal &&
                    <div className='column-delete-modal modal is-active'>
                        <div className='modal-container'>
                            <div className='modal-header'>
                                <OmniIconComponent icon-id='omni:informative:alert' class='is-size-1' />
                                <p className='modal-header-title'>
                                    Delete custom column
                                </p>
                            </div>
                            <div className='modal-content'>
                                <p>
                                    This action would delete custom column for this template! This action is permanent and will affect a whole hierarchy setup!How would you like to proceed?
                                </p>
                            </div>
                            <div className='modal-footer'>
                                <button className='button is-text is-warning' onClick={() => this.setState({ displayDeleteModal: false, deleteModalData: {} })}>
                                    Cancel
                                </button>
                                <button className='button is-outlined is-warning' onClick={() => this.removeCustomColumn(this.state.deleteModalData)}>
                                    Delete custom column
                                </button>
                            </div>
                        </div>
                    </div>}
            </div>
        );
    }
}
